<template id="input">
    <input
        v-model="value"
        :id="inputConfig.id"
        :class="getClassList"
        :placeholder="inputConfig.placeholderMsg"
        :type="inputConfig.type"
        :maxlength="inputConfig.maxlength"
        :tabindex="inputConfig.tabIndex"
        :ref="inputConfig.ref"
        :data-recurly="inputConfig.dataRecurly"
        :autocomplete="inputConfig.autoComplete"
        @input="updateValue()"
        @focus="handleFocus"
        @blur="handleBlur"
        @keydown="handleKeyDown"
    />
</template>

<script>
    import FormInputConfig from 'models/FormInputConfig';

    export default {
        name: 'InputElm',
        props: {
            inputConfig: {
                type: Object,
                default: FormInputConfig,
                required: true
            },
            keydownHandler: {
                type: Function,
                default: () => {}
            }
        },
        data: function () {
            return {
                focused: false,
                name: this.inputConfig.name,
                value: this.inputConfig.value
            };
        },
        created: function () {
            this.$emit('input', {
                value: this.value
            });
        },
        methods: {
            updateValue() {
                this.$emit('input', {
                    value: this.value
                });
            },
            handleKeyDown(e) {
                this.keydownHandler(e);
                this.triggerValidation('keydown');
            },
            handleFocus() {
                this.focused = true;
                this.triggerValidation('focus');
            },
            handleBlur() {
                this.focused = false;
                this.$emit('blur', {
                    name: this.name,
                    value: this.value
                });
                this.triggerValidation('blur');
            },
            triggerValidation(event) {
                this.$emit('runValidator', {
                    id: this.inputConfig.id,
                    on: event,
                    name: this.name,
                    value: this.value,
                    keyValue: this.keyValue
                });
            }
        },
        computed: {
            getClassList: function () {
                if (this.classList) return this.classList;
                if (this.inputConfig.styleClass) return this.inputConfig.styleClass;

                return null;
            }
        }
    };
</script>
